
import { Vue, Component, Prop } from 'vue-property-decorator';

import { User } from '@/generated/graphql';

import UiButton from '@/components/button/ui-button.vue';
import AuthFormLink from '@/components/auth/AuthFormLink.vue';
import AuthCard from '@/components/auth/AuthCard.vue';

import MaskedPhoneInput from '@/components/common/NewMaskPhone.vue';

import FormGroup from '@/components/form/FormGroup.vue';
import NewFormGroup from '@/components/form/NewFormGroup.vue';

@Component({
	components: {
		UiButton,
		AuthFormLink,
		AuthCard,
		FormGroup,
		NewFormGroup,
		MaskedPhoneInput,
	},
})
export default class PaymentV2 extends Vue {
	@Prop({ type: Object, default: () => ({}) }) record!: any;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	form = {
		firstName: null,
		lastName: null,
		email: null,
		phoneNumber: null,
		emergencyContact: {
			firstName: null,
			lastName: null,
			phoneNumber: null,
		},
	};
	phoneTouched: boolean = false;
	phoneHasErrors: boolean = false;

	activeStep: number = 0;
	created() {
		if (this.record) {
			this.form = {
				...this.form,
				...this.record,
			};
			return;
		}
		this.form = {
			...this.form,
			firstName: this.currentUser.given_name,
			lastName: this.currentUser.family_name,
			email: this.currentUser.private_data.email,
		};
	}
	submit() {
		this.$emit('onContinue', this.form);
	}
}
